import styled from 'styled-components';

export const StyledSearchWrapper = styled.main`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-bottom: 2.662rem;
`;
